module.exports = __webpack_public_path__ + "static/media/right.c3b2ef85.svg";